import React from 'react';
import { industryAnalysisReportType } from './industryAnalysisClass';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import IndustryAnalysisFinancialRatiosResult from './industryAnalysisFinancialRatiosResult';
import IndustryAnalysisStructuralIndicatorsResult from './industryAnalysisStructuralIndicatorsResult';
import NoDataComponent from '../../common/noDataComponent';

import "../../../css/search/search.scss";

class IndustryAnalysisResult extends React.Component {
    render() {
        const { year, pointer, nace } = this.props.computedMatch.params;

        if (isNullOrUndefined(year) || isNullOrUndefined(pointer) || isNullOrUndefined(nace))
            return (<NoDataComponent />);

        switch (pointer) {
            case (industryAnalysisReportType.financialRatios):
                return (<IndustryAnalysisFinancialRatiosResult year={year} nace={nace} language={this.props.user.language}></IndustryAnalysisFinancialRatiosResult>);
            case (industryAnalysisReportType.structuralIndicators):
                return (<IndustryAnalysisStructuralIndicatorsResult year={year} nace={nace} language={this.props.user.language}></IndustryAnalysisStructuralIndicatorsResult>);
            default:
                return (<NoDataComponent />);
        }
    }
}

export default IndustryAnalysisResult;